import type { RootState } from '~/types';

export const initialState: RootState = {
  token: null,
  user: null,
  loggedInState: 'loading',
  page_error: null,
  guide_signin: null,
  i18nLn: null,
  isWindowVisible: true,
};
